export default "__VITE_ASSET__b224676e__"